import React from "react";
import MemberReservationPanel from "../components/MemberReservationPanel";
import { useAuth } from "../context/AuthContext";

export default function ReservationPage() {
  const { auth } = useAuth();
  return (
    <div className="page">
      <h1 className="page-title">매장 예약</h1>
      <MemberReservationPanel accessToken={auth?.accessToken} />
    </div>
  );
}
